import headImg from '../../assets/images/trad-ire.jpg';

export const RolloverConstants = {
  labels: {
    ROLLOVER: 'ROLLOVER',
  },
  rolloverDetailsPage: {
    pageTitle: 'Provide your rollover details',
    stepperLabel: 'Provide account details',
    firstFormTitle: 'Rollover To:',
    labels: {
      firmName: 'Firm Name',
      accountType: 'Account Type',
      accountNumber: 'Account Number',
      TrowePrice: 'T. Rowe Price',
    },
    p: {
      first:
        'Make sure the following information matches what appears on your account statements from your external financial institution.',
    },
  },
  rolloverTypePage: {
    label: 'Choose a rollover type',
    heading: 'Choose the type of rollover you need',
    description:
      'A rollover can be direct or indirect, depending on how you request your previous plan provider to distribute your assets.',
    formHeading: 'Rollover Type',
    formDescription: 'How will you be handling your rollover?',
    directRolloverLabel:
      'Direct Rollover: I will request a check payable to T. Rowe Price from my plan provider (most common)',
    indirectRolloverLabel:
      ' Indirect Rollover: I am sending a check payable to T. Rowe Price.',
    amountHeading: 'Approximate Total Rollover Amount',
    amountDescription:
      'Enter the total estimated balance of the workplace retirement account.',
  },
  rolloverReviewPage: {
    label: 'Review your rollover',
    fundingMethodType: 'Employeer Plan Rollover',
    btnLabel: 'Generate My Rollover Guide',
    labels: {
      RolloverTo: 'Rollover To:',
    },
  },
  rolloverSummary: {
    fundingMethodType: 'Review your rollover',
    mobilePhone: '1-866-294-5526',
  },
  rolloverGuidePage: {
    indirect: {
      title: 'Rollover Guide (Indirect)',
      headerImgUrl:
        'https://media.istockphoto.com/id/1091766002/photo/its-never-too-late-to-join-the-online-community.jpg?s=612x612&w=0&k=20&c=gNidDNqePBYvCi2i3CKxW3hU3t9FDCKWXIO_FpsSsPI=',
      whatsNext:
        'Once we receive all your documents, we will process your rollover. A T. Rowe Price RolloverConcierge™ will reach out to you if any additional documents are needed.',
      content:
        'Get help from a T. Rowe Price RolloverConcierge™, available weekdays 8 a.m. - 8 p.m. ET.',
    },
    direct: {
      title: 'Rollover Guide (Direct)',
      description:
        "To complete your rollover, contact Institution name and tell them you'd like to initiate a rollover to your T. Rowe Price IRA.",
      sectionOne: {
        title:
          'Call Institution name to ask for a “direct rollover distribution.”',
      },
    },
    whatsNext:
      'It may take several weeks for <institution name> to send us your rollover check. A T. Rowe Price RolloverConcierge™ will reach out to you if any additional documents are needed.',
    footerTitle: '1-866-294-5526',
    btnLabel: 'Schedule a Call',
    headerImgUrl: headImg,
    content:
      'Get help from a T. Rowe Price RolloverConcierge™, available weekdays 8 a.m. - 8 p.m. ET.',
  },
  rolloverFunding: {
    link: {
      trpevents:
        'https://trpii-events.secure.force.com/cts?Id=BmHUJ3.r_II7SPf0tLqOApLsP2c0vU0jI_CtZ5TM1c8-',
      accountDashboardDev: 'usis/my-accounts/dashboard',
    },
  },
};
